import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { Cursor } from "./components/portfolio/Cursor";
import { Nav } from "./components/portfolio/Nav";
import { Hero } from "./components/portfolio/Hero";
import { Marquee } from "./components/portfolio/Marquee";
import { Metrics } from "./components/portfolio/Metrics";
import { Services } from "./components/portfolio/Services";
import { CaseStudy } from "./components/portfolio/CaseStudy";
import { Experience } from "./components/portfolio/Experience";
import { Stack } from "./components/portfolio/Stack";
import { Contact } from "./components/portfolio/Contact";
import { Footer } from "./components/portfolio/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="site-shell">
      <Cursor />
      <Nav />
      <main id="top">
        <Hero />
        <Marquee />
        <Metrics />
        <Services />
        <CaseStudy />
        <Experience />
        <Stack />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
